import { User } from "@models/identity/user"

export class InvoiceSettingsDto {
  id: number
  ownerUserId: string
  owner: User
  
  ceo?: string
  vatId?: string
  commercialRegister?: string
  commercialRegisterId?: string
  bank?: string
  iban?: string
  bic?: string
  
  isUsingStationery?: boolean
  stationaryFileUri?: string
  stationaryFileName?: string
  logoFileUri?: string
  logoFileName?: string
  letterheadHeight?: number
  footnoteHeight?: number
  isUsingFootnote?: boolean
}
